import clsx from 'clsx';
import React, { ReactNode } from 'react';

import styles from './DrawerContentWrapper.module.scss';

interface DrawerContentWrapperProps {
  children: ReactNode;
  className?: string;
}

export const DrawerContentWrapper = ({
  children,
  className,
}: DrawerContentWrapperProps) => (
  <div className={clsx(styles.root, className)}>{children}</div>
);
